import { Canvas } from "@react-three/fiber";
import { Float, MeshDistortMaterial, Icosahedron, Points, PointMaterial } from "@react-three/drei";
import { useMemo } from "react";
import * as THREE from "three";

function StarField() {
  const positions = useMemo(() => {
    const arr = new Float32Array(1400 * 3);
    for (let i = 0; i < arr.length; i++) arr[i] = (Math.random() - 0.5) * 12;
    return arr;
  }, []);
  return (
    <Points positions={positions} stride={3}>
      <PointMaterial transparent color="#00E5FF" size={0.018} sizeAttenuation depthWrite={false} opacity={0.55} />
    </Points>
  );
}

function Orb() {
  return (
    <Float speed={1.4} rotationIntensity={0.9} floatIntensity={1.1}>
      <Icosahedron args={[1.55, 12]}>
        <MeshDistortMaterial
          color="#052a2e"
          emissive="#00E5FF"
          emissiveIntensity={0.35}
          roughness={0.15}
          metalness={0.85}
          distort={0.42}
          speed={1.6}
          wireframe={false}
        />
      </Icosahedron>
      <Icosahedron args={[1.85, 3]}>
        <meshBasicMaterial color="#00E5FF" wireframe transparent opacity={0.08} />
      </Icosahedron>
    </Float>
  );
}

export default function HeroCanvas() {
  const reduced = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return null;
  return (
    <Canvas camera={{ position: [0, 0, 5], fov: 45 }} dpr={[1, 2]} gl={{ alpha: true, antialias: true }} style={{ pointerEvents: "none" }}>
      <ambientLight intensity={0.4} />
      <pointLight position={[3, 2, 4]} intensity={40} color="#00E5FF" />
      <pointLight position={[-4, -2, -2]} intensity={20} color="#A7F3D0" />
      <Orb />
      <StarField />
    </Canvas>
  );
}
